import { createSelector } from 'reselect';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import moment from 'moment';

const defaultSelectors = createMetadataAPISelectors({
  name: 'contractWorkloadBreakdown'
});

// Returns a function which allows filtering through contract workload
// breakdowns
// This function accepts the following parameters (all mandatory):
// - timeUnit (shift or hours)
// - periodType (week, month, quarter, year)
// - time: the time which lies somewhere inside the requested period type
// - contratId: the ID of the contract
const selectContractWorkloadBreakdownFilter = createSelector(defaultSelectors.byId, byId => {
  return (timeUnit, periodType, time, contractId) => {
    const contractData = byId[contractId];
    if (!contractData) return [];

    const key = `${periodType}_${timeUnit}`;
    const unitAndPeriodData = contractData.data[key] || [];

    return unitAndPeriodData.filter(
      stats =>
        // see comment in contract-statistics/selectors.js for details about this
        // code
        moment(time).isBetween(stats.start_time, stats.end_time, undefined, '[)') ||
        moment(time).isBetween(stats.start_time, stats.end_time, periodType, '[)')
    );
  };
});

export default {
  ...defaultSelectors,
  selectContractWorkloadBreakdownFilter
};
